import { useState } from "react";
import { PeopleList } from "./components/PeopleList";
import { PersonDetailView } from "./PersonDetailView";
import type { PersonListItem } from "./people.types";

type PageView = "list" | "detail";

// ENTERPRISE-only (see App.tsx's RequireRole navKey="people"). Mirrors
// OnboardingPage's list/detail state-machine shape — simpler here since
// this directory is read-only, no form/review views.
export function PeoplePage() {
  const [view, setView] = useState<PageView>("list");
  const [selectedId, setSelectedId] = useState<string | null>(null);

  function handleView(person: PersonListItem) {
    setSelectedId(person.id);
    setView("detail");
  }

  function handleBack() {
    setSelectedId(null);
    setView("list");
  }

  if (view === "detail" && selectedId) {
    return (
      <div className="p-4 sm:p-6">
        <PersonDetailView applicationId={selectedId} onBack={handleBack} />
      </div>
    );
  }

  return (
    <div className="p-4 sm:p-6">
      <PeopleList onView={handleView} />
    </div>
  );
}
